import React from "react";
import { useTranslation } from "react-i18next";
import { PendingIcon } from "src/components/deposit-statuses";
import "./withdrawal-status.scss";

const WithdrawalStatusStep: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  
  return (
    <main className="withdrawal-status">
      <section className="withdrawal-status-container">
        <div className="withdrawal-status-icon withdrawal-status-icon-pending">
          <PendingIcon />
        </div>
        <h1 className="withdrawal-status-title">{t("WITHDRAWAL_STEPS.WITHDRAWAL_SUBMITTED")}</h1>
        <p className="withdrawal-status-message">
          {t("WITHDRAWAL_STEPS.WITHDRAWAL_SUBMITTED_WILL_BE_PROCESSED")}
        </p>
      </section>
    </main>
  );
};

export default WithdrawalStatusStep;
